export default "__VITE_ASSET__BHWepZ$Q__"